import React from 'react';

type ChatInputProps = {
  isConnected: boolean;
  sendMsg: string;
  setSendMsg: (value: string) => void;
  handleSendMsg: () => void;
};

const ChatInput = ({isConnected, sendMsg, setSendMsg, handleSendMsg}: ChatInputProps) => (
    <div className="card-footer d-flex justify-content-between align-items-start gap-3 bg-light-subtle p-4 w-100"
         style={{position: "absolute", bottom: 0, right: 0}} id="kt_chat_messenger_footer">
    <textarea
        disabled={!isConnected}
        onChange={(e) => setSendMsg(e.target.value)}
        value={sendMsg}
        className="form-control form-control-flush mb-5"
        rows={1}
        data-kt-element="input"
        placeholder={isConnected ? "Xabaringizni yozing" : "Ulanmoqda..."}
    ></textarea>
      {sendMsg && (
          <button className="btn btn-primary" type="button" onClick={handleSendMsg} data-kt-element="send"
                  disabled={!isConnected}>
            Yuborish
          </button>
      )}
    </div>
);

export default ChatInput;